// extracted by mini-css-extract-plugin
module.exports = {"container":"NoContent_container__WeYtZ","icon":"NoContent_icon__WkRZY","title":"NoContent_title__saogD","desc":"NoContent_desc__V9rv4"};